import Flux from 'flux';
import { PayloadSources } from 'search/constants';
import Honeybadger from 'honeybadger-js';

const Dispatcher = Object.assign(new Flux.Dispatcher(), {
  /**
   * @param {object} action The details of the action, including the action's
   * type and additional data coming from the view.
   */
  handleViewAction(action) {
    const payload = {
      source: PayloadSources.VIEW_ACTION,
      action: action
    };
    this.dispatch(payload);
  },

  /**
   * @param {object} action The details of the action, including the action's
   * type and additional data coming from the server.
   */
  handleServerAction(action) {
    const payload = {
      source: PayloadSources.SERVER_ACTION,
      action: action
    };
    this.dispatch(payload);
  }
});

Dispatcher.dispatch = Honeybadger.wrap(Dispatcher.dispatch);

export default Dispatcher;
